// extracted by mini-css-extract-plugin
export default {"country-card":"Card_country-card__emkKK","country-info":"Card_country-info__7eHUp","country-name-link":"Card_country-name-link__OkJ04"};